import React from 'react';
import './BrandIcon.less';

type Props = {
  id?: string;
  name: string;
  style?: any;
  dotTestid?: string;
};

const BrandIcon = ({ id, name, style, dotTestid }: Props) => {
  return (
    <svg
      data-testid={
        name === 'iconIncomplete'
          ? `BrandIcon-${dotTestid}-redDot`
          : `BrandIcon-${dotTestid}-arrow`
      }
      id={id}
      className="brand-icon"
      style={style}
    >
      <use id={id} xlinkHref={`/svg/${name}.svg#icon`} />
    </svg>
  );
};

BrandIcon.defaultProps = {
  id: '',
  style: {},
};

export default React.memo(BrandIcon);
